import React from 'react';

const UniversalLibraryHeader = () => {
  return null; // Header is now empty, search moved to sidebar
};

export default UniversalLibraryHeader;
